/**
 * External Dependencies
 */
import 'jquery';
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  },
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  },
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, { passive: true });
  },
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, { passive: true });
  },
};

import lozad from 'lozad';
const observer = lozad();
observer.observe();

import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox';

import './custom';

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faChevronDown, faChevronLeft, faChevronRight, faCaretLeft, faCaretRight, faChevronDoubleRight, faArrowRight, faTimes, faShare, faLongArrowRight, faPoundSign, faDownload, faMinus, faPlus, faAt, faStar, faHandshake, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { faAward, faBoxCheck, faBriefcase, faBusinessTime, faCalendarAlt, faCalendarCheck, faCheckCircle, faCheckDouble, faCheckSquare, faCheck, faClipboardCheck, faCloudSunRain, faCommentAlt, faCommentSlash, faCrown, faEye, faFileInvoiceDollar, faGem, faHammer, faHandHolding, faHandSparkles, faHandsHelping, faLeaf, faLockAlt, faLock, faMedal, faMoneyCheckEditAlt, faMoneyCheck, faPalette, faPencilAlt, faPencilRuler, faPlug, faRecycle, faScrewdriver, faSeedling, faShieldAlt, faShield, faSun, faSwatchbook, faTachometerAlt, faThermometerHalf, faThermometerQuarter, faTools, faTrophyAlt, faTrophy, faUserCheck, faWind, faWrench, faSearchPlus, faQuoteLeft, faQuoteRight, faArrowDown } from '@fortawesome/pro-light-svg-icons';
import { faMobile } from '@fortawesome/pro-regular-svg-icons';
import { faFacebook, faFacebookF, faFacebookSquare, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin, faGoogle } from '@fortawesome/free-brands-svg-icons';
config.searchPseudoElements = true;
library.add(faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faFacebook, faFacebookF, faFacebookSquare, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin, faGoogle, faChevronDown, faChevronLeft, faChevronRight, faChevronDoubleRight, faDownload, faCaretLeft, faCaretRight, faArrowRight, faArrowDown, faTimes, faShare, faAward, faBoxCheck, faBriefcase, faBusinessTime, faCalendarAlt, faCalendarCheck, faCheckCircle, faCheckDouble, faCheckSquare, faCheck, faClipboardCheck, faCloudSunRain, faCommentAlt, faCommentSlash, faCrown, faEye, faFileInvoiceDollar, faGem, faHammer, faHandHolding, faHandSparkles, faHandsHelping, faLeaf, faLockAlt, faLock, faMedal, faMoneyCheckEditAlt, faMoneyCheck, faPalette, faPencilAlt, faPencilRuler, faPlug, faRecycle, faScrewdriver, faSeedling, faShieldAlt, faShield, faSun, faSwatchbook, faTachometerAlt, faThermometerHalf, faThermometerQuarter, faTools, faTrophyAlt, faTrophy, faUserCheck, faWind, faWrench, faLongArrowRight, faPoundSign, faMinus, faPlus, faAt, faStar, faSearchPlus, faQuoteLeft, faQuoteRight, faHandshake, faMobile, faSearch);
dom.i2svg();

// import Vue from 'vue';
// import { vueRouter, createRouter, createWebHistory } from 'vue-router'
// createRouter({
//   history: createWebHistory('/shop'),
//   routes: [
//     {
//       path: '/shop',
//       name: 'index',
//       component: Shop,
//       meta: {
//         title: 'Shop'
//       }
//     }
//   ]
// })
//
// import Shop from './views/Shop';
// import { createApp } from 'vue'
// createApp({
//   components: { Shop },
// }).mount('#shop');
